import { Calendar, ConfigProvider } from "antd";
import classNames from "classnames";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { getFormattedLocale } from "@/features/calendar/model";
import type { Dayjs } from "dayjs";
import { CalendarHeader } from "../calendar-header";
import { useCalendarViewMobile } from "../hooks";
import { CellRenderMobileDashboard } from "../cell-render";
import { CalendarFooter } from "../calendar-footer";
import { EventList } from "../event-list";
import styles from "./styles.module.scss";

export const CalendarViewMobileDashboard = () => {
  const { i18n } = useTranslation();
  const { selectedDate, onChange } = useCalendarViewMobile();

  return (
    <div className={classNames(styles.wrapper, styles["wrapper--dashboard"])}>
      <ConfigProvider locale={getFormattedLocale(i18n.language)}>
        <Calendar
          value={dayjs(selectedDate)}
          className={classNames(styles.calendar, styles["calendar-ru"])}
          fullscreen={false}
          headerRender={({ value }) => <CalendarHeader value={value} />}
          fullCellRender={(value: Dayjs) => <CellRenderMobileDashboard date={value} />}
          onChange={onChange}
        />
        <CalendarFooter />
        <EventList />
      </ConfigProvider>
    </div>
  );
};
